import React, { memo, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Callout } from '@node-space/ui-components'
import { SourcePayWallet } from '../../Pay/types'

interface BeneficiaryFormCalloutProps {
  isInsufficientBalance: boolean
  isPayoutsSupported: boolean
  wallet: SourcePayWallet
}
const BeneficiaryFormCallout = ({
  isInsufficientBalance,
  isPayoutsSupported,
  wallet,
}: BeneficiaryFormCalloutProps) => {
  const { t } = useTranslation()

  return useMemo(() => {
    if (!wallet) return

    if (isInsufficientBalance && isPayoutsSupported) {
      return (
        <Callout variant="error">
          {t('payInsufficient', { currencyCode: wallet?.currency })}
        </Callout>
      )
    }

    if (!isPayoutsSupported) {
      return <Callout variant="error">{t('payoutsNotSupported')}</Callout>
    }
  }, [wallet, isInsufficientBalance, isPayoutsSupported])
}

export default memo(BeneficiaryFormCallout)
